import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { Params, Router } from '@angular/router';
import { SharesPayloadParts } from '@common/components/modals/my-booking-itinerary/shares/shares-payload.state';
import { isEmptyArray, isStringEmpty } from '@common/helpers';
import { ITINERARY_TYPE, AMC_ENDPOINT_ID } from '@common/helpers/constants/my-booking/my_booking_itinerary.contant';
import { EXTERNAL_SITE_CATEGORY_BIZ_MNT } from '@common/helpers/constants/servicing.contant';
import { BookingDateFormat } from '@common/interfaces';
import { MyBooking, UnEnrolledPassenger } from '@common/interfaces/mybooking/mybooking.interface';
import { ServicingCommonStoreService } from '@common/services';
import { MyBookingItineraryService } from '@common/services/my-booking/my-booking-itinerary.service';
import { MyBookingStoreService } from '@common/services/my-booking/my-booking-store.service';
import { MyBookingService } from '@common/services/my-booking/my-booking.service';
import { NextActionService } from '@common/services/next-action/next-action.service';
import { PassAmcInformationStoreService } from '@common/services/pass-amc-information-store/pass-amc-information.service';
import { SERVICING_ROUTES } from '@conf/routes.config';
import { SupportComponent } from '@lib/components/support-class';
import {
  AnaBizLoginStatusType,
  ApiCommonRequest,
  DeviceType,
  LoginStatusType,
  PageType,
  SessionStorageName,
} from '@lib/interfaces';
import { AnaBizContextStoreService, CommonLibService, ModalService, PageLoadingService } from '@lib/services';
import { Subscription, take, filter, map } from 'rxjs';
import { AmcmemberApiService, GetBasicReservationInformationRequest } from 'src/sdk-amcmember';
import {
  FavoritePostRequest,
  FavoritePostRequestFavorite,
  FavoritePostResponse,
  HistoryPostRequestHistoryBoundsInner,
  HistoryPostRequestHistoryRoundtrip,
  NumberOfTravelers,
  DefaultService as SearchApiService,
} from 'src/sdk-search';
import {
  Bound,
  GetOrderResponseData,
  GetOrderResponseDataAir,
  GetOrderResponseDataContactsRepresentativeEmailsInner,
  GetOrderResponseDataNextActions,
  GetOrderResponseDataOrderEligibilities,
  GetOrderResponseDataOrderEligibilitiesEligibilityLevel,
  GetOrderResponseDataOrderType,
  Type1,
} from 'src/sdk-servicing';
import { v4 } from 'uuid';
import { I18N_CONFIG } from '@conf/i18n.config';
import { FrequentFlyerCards } from '@common/interfaces/frequent-flyer-cards';
import { IFlyMemberInfo } from 'src/sdk-member';
import { Store, select } from '@ngrx/store';
import { selectGetMemberInformationState, GetMemberInformationStore } from '@lib/store';

@Component({
  selector: 'asw-my-booking-slidebar-menu',
  templateUrl: './my-booking-slidebar-menu.component.html',
  styleUrls: ['./my-booking-slidebar-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyBookingSlidebarMenuComponent extends SupportComponent {
  /** Condition value variable display for each screen (S01-P032, S01-P033) with MENU */
  /**
   * S01-P032 [15.1] 旅程操作メニュー
   * S01-P033 [1.14] 旅程操作メニュー
   */
  @Input() isItineraryMenuByScreenShow: boolean = true;
  /**
   * S01-P032 [15.2] ANA新規入会
   * S01-P033 [1.15] ANA新規入会
   */
  @Input() isAnaMemberByScreenShow: boolean = true;
  /**
   * S01-P032 [15.4] Biz操作メニュー
   */
  @Input() isBizMenuByScreenShow: boolean = true;
  /**
   * S01-P032 [15.3] レコメンド
   * S01-P033 [1.17] レコメンド
   */
  @Input() isRecommentByScreenShow: boolean = true;

  /** Initialize variables for S01-P031 */
  public configObj = {
    /** S01-P031 [1.3.1] 旅程操作メニュー */
    isItineraryMenuByScreenShow: false,
    /** S01-P031 [1.3.3] 予約変更 */
    isReservationChangeShow: false,
    /** S01-P031 [1.3.4] Acknowledge */
    isAcknowledgeShow: false,
    /** S01-P031 [1.3.5] Self Reaccommodation */
    isSelfReaccommodationShow: false,
    /** S01-P031 [1.3.6] 解約 */
    isCancellationShow: false,
    /** S01-P031 [1.3.7] 領収書 */
    isReceiptShow: false,
    /** S01-P031 [1.3.9] 旅程共有 */
    isItinerarySharingShow: true,

    /** S01-P031 [1.4.1] レコメン */
    isRecommentByScreenShow: false,

    /** S01-P031 [1.11.1] ANAマイレージクラブ入会案内 */
    isAnaMemberByScreenShow: false,

    /** S01-P031 [1.12.1] Biz操作メニュー */
    isBizMenuByScreenShow: false,
    /** S01-P031 [1.12.2] 出張旅程一覧 */
    isBusinessTrip: false,
    /** S01-P031 [1.12.3] 発券要求一覧 */
    isTicketRequest: false,
  };
  /** S01-P031 [1.11] ANAマイレージクラブ入会案内について、下記の通りに設定する。*/
  unEnrolledPassengers: UnEnrolledPassenger[] = [];

  flights: Array<Type1> = [];
  public isActiveBtnRegisterFavorites: boolean = false;
  public pnr!: GetOrderResponseData;
  private readonly _subscriptions: Subscription = new Subscription();

  selectedUnEnrolledPassenger!: UnEnrolledPassenger;
  constructor(
    public _change: ChangeDetectorRef,
    private readonly _modal: ModalService,
    private readonly _common: CommonLibService,
    private readonly _myBookingItineraryService: MyBookingItineraryService,
    private readonly _myBookingService: MyBookingService,
    private readonly _anaBizContextStoreService: AnaBizContextStoreService,
    private readonly _servicingCommonStoreService: ServicingCommonStoreService,
    private readonly _myBookingStoreService: MyBookingStoreService,
    private readonly _router: Router,
    private readonly _datePipe: DatePipe,
    private readonly _searchApiService: SearchApiService,
    private readonly _nextActionService: NextActionService,
    private readonly _passengerAmcInformationService: PassAmcInformationStoreService,
    private readonly _pageLoadingService: PageLoadingService,
    private _store: Store<GetMemberInformationStore>
  ) {
    super(_common);
  }

  init() {
    /** S01-P031 [1.3.1] 旅程操作メニュー */
    this.showItineraryOperationMenu();

    /** S01-P031 [1.4.1] レコメンド */
    if (this._common.aswContextStoreService.aswContextData?.deviceType === DeviceType.PC) {
      this.configObj.isRecommentByScreenShow = true;
    }

    this._subscriptions.add(
      this._servicingCommonStoreService.getServicingCommonModel$().subscribe((servicingCommon) => {
        this.pnr = servicingCommon.getOrder ?? ({} as GetOrderResponseData);
        this.flights =
          this.pnr?.air?.bounds?.flatMap((bound: Bound) => bound.flights ?? ([] as Type1[])) ?? ([] as Type1[]);
        this.getItineraryOperationMenu();
        this._change.markForCheck();
      })
    );
    this._subscriptions.add(
      this._myBookingStoreService.getMyBookingModel$().subscribe((state) => {
        this.isActiveBtnRegisterFavorites = state.favoriteBtnIsRegistered ?? false;
        this._change.markForCheck();
      })
    );
  }

  reload(): void {
    /* override abstract reload function of base class */
  }

  destroy(): void {
    if (this._subscriptions) {
      this._subscriptions.unsubscribe();
    }
    this._passengerAmcInformationService.resetPassAmcInformationStore();
  }

  get showHiddenMenu(): boolean {
    return (
      (this.configObj.isItineraryMenuByScreenShow && this.isItineraryMenuByScreenShow) ||
      (this.configObj.isAnaMemberByScreenShow && this.isAnaMemberByScreenShow) ||
      (this.configObj.isBizMenuByScreenShow && this.isBizMenuByScreenShow) ||
      (this.configObj.isRecommentByScreenShow && this.isRecommentByScreenShow)
    );
  }

  /** S01-P031 [1.3] 旅程操作メニューについて、下記の通りに設定する。*/
  getItineraryOperationMenu() {
    const orderEligibilities = this.pnr?.orderEligibilities || {};
    const nextActions = this.pnr?.nextActions || {};
    const eligibilityLevel = orderEligibilities.eligibilityLevel || {};
    const channelType = this.pnr?.orderType?.channelType ?? GetOrderResponseDataOrderType.ChannelTypeEnum.Nh;
    this.checkIndividualOperations(orderEligibilities);

    /** S01-P031 [1.3.9] 旅程共有 */
    this.configObj.isItinerarySharingShow = this.shouldShowItinerarySharing(
      eligibilityLevel,
      channelType,
      this.pnr?.contacts?.representative?.emails as Array<GetOrderResponseDataContactsRepresentativeEmailsInner>,
      nextActions
    );
  }

  /** S01-P031 [1.3.1] 旅程操作メニュー */
  showItineraryOperationMenu(): void {
    /**
     * 当パーツは以下条件に応じた表示とする。
     * 1)ユーザ共通情報.data.aswContext.deviceType=“PC”版の場合、当画面内に常時表示する。表示位置は画面右部に固定とする。(垂直方向スクロールに追従し表示する。)
     * 2)ユーザ共通情報.data.aswContext.deviceType=“SP”または"TAB"版の場合、旅程情報の下に表示する
     */
    if (
      this._common.aswContextStoreService.aswContextData?.deviceType === DeviceType.PC ||
      this._common.aswContextStoreService.aswContextData?.deviceType === DeviceType.TABLET ||
      this._common.aswContextStoreService.aswContextData?.deviceType === DeviceType.SMART_PHONE
    ) {
      this.configObj.isItineraryMenuByScreenShow = true;
    }
  }

  /** [1.3.9] 旅程共有 */
  shouldShowItinerarySharing(
    eligibilityLevel: GetOrderResponseDataOrderEligibilitiesEligibilityLevel,
    channelType: GetOrderResponseDataOrderType.ChannelTypeEnum,
    emails: Array<GetOrderResponseDataContactsRepresentativeEmailsInner>,
    nextActions: GetOrderResponseDataNextActions
  ) {
    /** 1) 全便PNR情報取得API応答.data.bounds.flights.isOpenSegment=true(OPEN便) */
    const allFlightsOpen = this.pnr?.air?.bounds?.some((bo) => bo?.flights?.some((fl) => !fl.isOpenSegment));
    if (!allFlightsOpen) return false;

    /**
     * 2) PNR情報取得API応答.data.orderEligibilities.eligibilityLevel.level="1"(予約操作不可PNR)、
     * かつPNR情報取得API応答.orderEligibilities.eligibilityLevel.restrictedReasons[]内に"pnrUnmodifiablePtc"が無い (ASWで定めるPNR更新不可旅客種別(設定ファイルに定義)のみのPNR)
     */
    const isExistPnrUnmodifiablePtc = eligibilityLevel?.restrictedReasons?.includes(
      GetOrderResponseDataOrderEligibilitiesEligibilityLevel.RestrictedReasonsEnum.PnrUnmodifiablePtc
    );

    if (
      eligibilityLevel?.level === GetOrderResponseDataOrderEligibilitiesEligibilityLevel.LevelEnum._1 &&
      isExistPnrUnmodifiablePtc === false
    ) {
      return false;
    }

    /** 3) PNR情報取得APII結果.data.orderType.channelType="nh"(直営PNR)または"ndc"(NDC PNR)でPNR情報取得API応答.data.contacts.representative.emails[0].addressが空 */
    const isNhOrNdc =
      channelType === GetOrderResponseDataOrderType.ChannelTypeEnum.Nh ||
      channelType === GetOrderResponseDataOrderType.ChannelTypeEnum.Ndc;
    const address = emails?.[0]?.address;

    if (isNhOrNdc && isStringEmpty(address)) {
      return false;
    }

    /** 4) PNR情報取得APII結果.data.nextActions.acknowledgeOrSelfReaccommodation=true */
    if (nextActions.acknowledgeOrSelfReaccommodation) return false;

    return true;
  }

  checkIndividualOperations(orderEligibilities: GetOrderResponseDataOrderEligibilities): void {
    const { change, flightReaccommodation, cancel, receipt } = orderEligibilities;
    /** S01-P031 [1.3.3] 予約変更 */
    if (
      change?.isEligibleToForward ||
      (change?.isEligibleToForward === false &&
        this._myBookingService.getIsReservationChangeShowForStaff(orderEligibilities.eligibilityLevel!))
    ) {
      /** PNR情報取得API応答.data.orderEligibilities.change.isEligibleToForward = trueの場合、表示する。*/
      /** 提携： または、PNR情報取得API応答.data.orderEligibilities.change.isEligibleToForward = false、かつ以下すべての条件に一致する
       *    ユーザ共通情報.操作オフィスコードがWEB社用オフィスリスト(※1)に含まれる
       *    PNR情報取得API応答.data.orderEligibilities.eligibilityLevel.level = “2”
       *    PNR情報取得API応答.data.orderEligibilities.eligibilityLevel.restrictedReasons[]が”staffBooking”のみである。
       */
      this.configObj.isReservationChangeShow = true;
    }

    /** S01-P031 [1.3.4] Acknowledge */
    if (flightReaccommodation?.acknowledge?.isEligibleToForward) {
      /**
       * 以下の条件に応じて表示する。
       * 1)PNR情報取得API応答.data.orderEligibilities.flightReaccommodation.acknowledge.isEligibleToForward = trueの場合、"label.alternativeFlight"を表示する。
       * 2) 上記以外の場合、非表示する。
       */
      this.configObj.isAcknowledgeShow = true;
    }

    /** S01-P031 [1.3.5] Self Reaccommodation */
    if (flightReaccommodation?.change?.isEligibleToForward) {
      /**
       * 以下の条件に応じて表示する。
       * 1)PNR情報取得API応答.data.orderEligibilities.flightReaccommodation.change.isEligibleToForward = trueの場合、"label.selfReaccFlight"を表示する。
       * 2) 上記以外の場合、非表示する。
       */
      this.configObj.isSelfReaccommodationShow = true;
    }

    /** S01-P031 [1.3.6] 解約 */
    if (cancel?.isEligibleToForward) {
      /** PNR情報取得API応答.data.orderEligibilities.cancel.isEligibleToForward=trueの場合、表示する。*/
      this.configObj.isCancellationShow = true;
    }

    /** S01-P031 [1.3.7] 領収書 */
    if (receipt?.isEligibleToForward) {
      /** PNR情報取得API応答.data.orderEligibilities.receipt.isEligibleToForward= trueの場合、表示する。*/
      this.configObj.isReceiptShow = true;
    }
  }

  /** (7)「予約変更」ボタン押下時 */
  clickChange() {
    this._myBookingService.onHandleChange(this.pnr);
  }

  /** (28)「Acknowledge」ボタン押下時	*/
  clickAcknowledge() {
    this._nextActionService.onHandleAcknowledge(this.pnr);
  }

  /** (29)「Self Reaccommodation」ボタン押下時 */
  clickSelfReaccommodation() {
    this._nextActionService.onHandleSelfReacCommodation(this.pnr);
  }

  /** (8) 解約」ボタン押下時 */
  clickCancel() {
    this._myBookingService.onHandleCancel(this.pnr ?? {});
  }

  /** (9)「領収書」ボタン押下時 */
  clickReceipt() {
    // PNRチャネル区分がNH0,NH3だった場合は継続可能エラー
    const receiptChannelType = this.pnr?.orderType?.channelType;
    if (
      receiptChannelType === GetOrderResponseDataOrderType.ChannelTypeEnum.Nh0 ||
      receiptChannelType === GetOrderResponseDataOrderType.ChannelTypeEnum.Nh3
    ) {
      this._common.errorsHandlerService.setRetryableError(PageType.PAGE, { errorMsgId: 'EA037' });
      return;
    }
    this._myBookingService.onHandleReceipt(this.pnr);
  }

  getItineraryType(boundList: Bound[]): string {
    // バウンドリストの要素数 = 2 、かつバウンドリスト[0].originLocationCode = バウンドリスト[1].destinationLocationCodeの場合、""roundtrip""とする。
    if (boundList.length === 2 && boundList[0]?.originLocationCode === boundList[1]?.destinationLocationCode) {
      return FavoritePostRequestFavorite.TripTypeEnum.Roundtrip;
    }
    // 上記以外の場合、onewayOrMulticityとする
    return FavoritePostRequestFavorite.TripTypeEnum.OnewayOrMulticity;
  }

  getBoundListItinerary(bounds: Bound[]) {
    const listBound: HistoryPostRequestHistoryBoundsInner[] = [];
    bounds.forEach((bound) => {
      listBound.push({
        // 出発空港コード
        // 当該旅程バウンドoriginLocationCode  + "+"
        originLocationCode: bound?.originLocationCode + '+',
        // 到着空港コード
        // 当該旅程バウンド.destinationLocationCode + "+"
        destinationLocationCode: bound?.destinationLocationCode + '+',
        // 往路出発日 (yyyy-MM-dd)
        // 当該旅程バウンド.originDepartureDateTime(yyyy-MM-dd'T'HH:mm:ss形式)
        departureDate: this.getDateTime(bound?.originDepartureDateTime, BookingDateFormat.yyyy_MM_dd),
        // 出発開始時刻 (HH:mm:ss)
        // 当該旅程バウンド.originDepartureDateTime(yyyy-MM-dd'T'HH:mm:ss形式)
        departureTimeWindowFrom: this.getDateTime(bound?.originDepartureDateTime, BookingDateFormat.HHmmss),
        // 出発終了時刻 (HH:mm:ss)
        // 当該旅程バウンド.destinationArrivalDateTime(yyyy-MM-dd'T'HH:mm:ss形式)
        departureTimeWindowTo: this.getDateTime(bound?.destinationArrivalDateTime, BookingDateFormat.HHmmss),
      });
    });

    return listBound;
  }

  getRoundTripItinerary(bounds: Bound[]): HistoryPostRequestHistoryRoundtrip {
    const roundTripItinerary: HistoryPostRequestHistoryRoundtrip = {
      // 出発空港コード
      // バウンドリスト[0].originLocationCode + "+"
      originLocationCode: bounds[0]?.originLocationCode + '+',
      // 到着空港コード
      // バウンドリスト[0].destinationLocationCode + "+"
      destinationLocationCode: bounds[0]?.destinationLocationCode + '+',
      // 往路出発日 (yyyy-MM-dd)
      // バウンドリスト[0].originDepartureDateTime(yyyy-MM-dd'T'HH:mm:ss形式)
      departureDate: this.getDateTime(bounds[0]?.originDepartureDateTime, BookingDateFormat.yyyy_MM_dd),
      // 往路出発開始時間 (HH:mm:ss)
      // バウンドリスト[0].originDepartureDateTime(yyyy-MM-dd'T'HH:mm:ss形式)
      departureTimeWindowFrom: this.getDateTime(bounds[0]?.originDepartureDateTime, BookingDateFormat.HHmmss),
      // 往路出発終了時刻(HH:mm:ss)
      // バウンドリスト[0].destinationArrivalDateTime(yyyy-MM-dd'T'HH:mm:ss形式)
      departureTimeWindowTo: this.getDateTime(bounds[0]?.destinationArrivalDateTime, BookingDateFormat.HHmmss),
      // 復路出発日 (yyyy-MM-dd)
      // バウンドリスト[1].originDepartureDateTime(yyyy-MM-dd'T'HH:mm:ss形式)
      returnDate: this.getDateTime(bounds[1]?.originDepartureDateTime, BookingDateFormat.yyyy_MM_dd),
      // 復路出発開始時刻(HH:mm:ss)
      // バウンドリスト[1].originDepartureDateTime(yyyy-MM-dd'T'HH:mm:ss形式)
      returnTimeWindowFrom: this.getDateTime(bounds[1]?.originDepartureDateTime, BookingDateFormat.HHmmss),
      // 復路出発終了時刻(HH:mm:ss)
      // バウンドリスト[1].destinationArrivalDateTime(yyyy-MM-dd'T'HH:mm:ss形式)
      returnTimeWindowTo: this.getDateTime(bounds[1]?.destinationArrivalDateTime, BookingDateFormat.HHmmss),
    };

    return roundTripItinerary;
  }

  get haveSeparateReservation() {
    const totalTravelers = this.pnr?.travelersSummary?.travelerNumbers?.total ?? 0;
    const childNumbers = this.pnr?.travelersSummary?.travelerNumbers?.CHD ?? 0;

    if (
      // 1.PNR情報取得API応答.data.air.tripType=""domestic""(日本国内単独旅程)、
      this.pnr?.air?.tripType === GetOrderResponseDataAir.TripTypeEnum.Domestic &&
      // かつPNR情報取得API応答.data.travelersSummary.travelerNumbers.CHD>0、
      childNumbers > 0 &&
      // かつ PNR情報取得API応答.data.travelersSummary.travelerNumbers.total=PNR情報取得API応答.data.travelersSummary.travelerNumbers.CHD(PNR内の搭乗者が小児のみ)の場合、
      totalTravelers === childNumbers
    ) {
      // 1.1PNR情報取得API応答.data.orderType.isSoloChildBooking=true(大人が同行しない小児単独予約である)の場合、falseとする。
      if (this.pnr?.orderType?.isSoloChildBooking === true) return false;

      // 1.2PNR情報取得API応答.data.orderType.isSoloChildBooking=false(大人が同行する小児単独予約である、または小児単独予約でない)の場合、trueとする。
      if (this.pnr?.orderType?.isSoloChildBooking === false) return true;
    }

    // 2.上記以外の場合、別予約同行者有無は登録しない。
    return undefined;
  }

  get getCabinType(): string {
    // PNR情報取得API応答.data.air.tripType="domestic"(日本国内単独旅程)または"international"(国際旅程)の場合、 PNR情報取得API応答.data.air.highestCabinClass
    if (
      this.pnr?.air?.tripType === GetOrderResponseDataAir.TripTypeEnum.Domestic ||
      this.pnr?.air?.tripType === GetOrderResponseDataAir.TripTypeEnum.International
    ) {
      return this.pnr?.air?.highestCabinClass ?? '';
    }

    return '';
  }

  get passengerNumbersInFo(): NumberOfTravelers {
    const info: NumberOfTravelers = {
      // 大人人数
      ADT: this.pnr?.travelersSummary?.travelerNumbers?.ADT ?? 0,
      // ヤングアダルト人数
      B15: this.pnr?.travelersSummary?.travelerNumbers?.B15 ?? 0,
      // 小児人数
      CHD: this.pnr?.travelersSummary?.travelerNumbers?.CHD ?? 0,
      // 幼児人数
      INF: this.pnr?.travelersSummary?.travelerNumbers?.INF ?? 0,
    };

    return info;
  }

  /** (11)「旅程共有」ボタン押下時 */
  clickShareItinerary(): void {
    // 1.	旅程共有モーダルを表示する。
    const part = SharesPayloadParts();
    this._modal.showSubModal(part);
    // 2	以下の条件を全て満たす場合、パスワードをリクエストに含めず、会員情報取得APIを実行する。
    // 2.1	PNR情報取得API応答.data.contacts.representative.emails[]が存在しない、またはPNR情報取得API応答.data.contacts.representative.emails[0].address = ""(空欄)
    // 2.2	ユーザ共通情報.data.aswContext.loginStatus = "REAL_LOGIN"(リアルログイン)
    if (
      !this.pnr?.contacts?.representative?.emails?.[0]?.address &&
      this._common.aswContextStoreService.aswContextData?.loginStatus === LoginStatusType.REAL_LOGIN
    ) {
      // 3 会員情報取得APIの呼び出しを行う。
      // 3.1 リクエスト情報
      this._common.amcMemberStoreService.saveMemberInformationToAMCMember$().subscribe();

      this._subscriptions.add(
        this._store
          .pipe(
            select(selectGetMemberInformationState),
            map((state) => state && state.model?.data),
            filter((data): data is IFlyMemberInfo => !!data)
          )
          .subscribe({
            next: (res) => {
              this._myBookingItineraryService.memberInformation$.next(res);
            },
            error: (error) => {
              // 3.2. エラーにより情報が取得できなかった場合、処理を続行する。
            },
          })
      );
    }
  }

  getDynamicId(): string {
    return `${v4()}`;
  }

  getDateTime(dateTime?: string, formatDate?: string): string {
    return this._datePipe.transform(dateTime, formatDate) ?? '';
  }

  getUrlByLang(lang: string) {
    // 1)ユーザ共通情報.data.aswContext.lang=“ja”(日本語)の場合、AMC入会ページURL + "ja/jp/amc/signup/"
    if (lang === I18N_CONFIG.supportedLocales['ja']) {
      return AMC_ENDPOINT_ID.JA;
    }
    // 2)ユーザ共通情報.data.aswContext.lang=“cn"(中国語(簡体字)),"tw","hk","zh"の場合、リダイレクト先URL + "/zh/jp/amc/signup/"
    if (lang === 'cn') {
      return AMC_ENDPOINT_ID.ZH;
    }
    // 3)ユーザ共通情報.data.aswContext.lang=“it”(イタリア語)の場合、リダイレクト先URL + "/it/it/amc/signup/"
    if (lang === 'it') {
      return AMC_ENDPOINT_ID.IT;
    }
    // 4)上記以外の場合、AMC入会ページURL + "en/jp/amc/signup/"
    return AMC_ENDPOINT_ID.EN;
  }

  openModalFormAction(url: string, params: Params) {
    const form = document.createElement('form');
    form.target = 'Map';
    form.method = 'POST';
    form.action = url;

    for (const [key, value] of Object.entries(params ?? {})) {
      const input = document.createElement('input');
      if (!isStringEmpty(value)) {
        input.type = 'hidden';
        input.name = key;
        input.value = value!;
        form.appendChild(input);
      }
    }

    document.body.appendChild(form);

    window.open('', 'Map', 'status=0,title=0,width=600,height=400,scrollbars=1');

    form.submit();
    document.body.removeChild(form);
  }
}
